import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function login(params) {
    const { baseUrl, brandId, country, credentials, clientId, clientSecret, uberToken, additionalHeaders = {} } = params;

    invariant(baseUrl, 'baseUrl is a required param of login()');
    invariant(brandId, 'brandId is a required param of login()');
    invariant(country, 'country is a required param of login()');
    invariant(credentials, 'credentials is a required param of login()');
    invariant(clientId, 'clientId is a required param of login()');

    const headers = { 'Content-Type': 'application/json', ...additionalHeaders };
    const url = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/loginidentity/v2`;
    const body = JSON.stringify(credentials);

    return labelRequest(
        authenticatedRequest(new Request(url, { headers: new Headers(headers), method: 'POST', body }), uberToken, clientId, clientSecret),
        'login',
    );
}
